

















import Vue, { PropType } from "vue";

import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { InstallationStatusEnum, installationStatusEnumLabel } from "@/model/data/status/InstallationStatusEnum";

export default Vue.extend({
    data() {
        return {};
    },
    props: {
        widget: Object as PropType<DashboardWidget>,
    },
    computed: {
        availableStatus() {
            var res = [];

            Object.values(InstallationStatusEnum)
                .filter((k) => !isNaN(Number(k)))
                .forEach((k) => {
                    // console.log("K", k);
                    res.push({
                        value: k,
                        text: this.$t(installationStatusEnumLabel(k as InstallationStatusEnum)),
                    });
                });

            // console.log("res", res);

            return res;
        },
    },
});
